import { render } from "./Produtos.vue?vue&type=template&id=d97c5f2e"
import script from "./Produtos.vue?vue&type=script&lang=js"
export * from "./Produtos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/facilitabots.interagev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__